import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownMenu, DropdownToggle, Form, Tooltip } from 'reactstrap';

//import images - removed old Velzon logos

//import Components
import SearchOption from '../Components/Common/SearchOption';
import LanguageDropdown from '../Components/Common/LanguageDropdown';
import FullScreenDropdown from '../Components/Common/FullScreenDropdown';
import NotificationDropdown from '../Components/Common/NotificationDropdown';
import ProfileDropdown from '../Components/Common/ProfileDropdown';
import LightDark from '../Components/Common/LightDark';

import { changeSidebarVisibility } from '../slices/thunks';
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from 'reselect';
import { useAuth } from '../contexts/AuthContext';
import { ebayApi, productsApi } from '../services/api';
import { POLLING_INTERVALS, createSmartInterval } from '../utils/polling';
import { ABONELIK_GUNCELLENDI_OLAYI } from '../helpers/odemeDonusu';

const Header = ({ onChangeLayoutMode, layoutModeType, headerClass } : any) => {
    const dispatch : any = useDispatch();
    const { token, user, isImpersonating, exitImpersonation } = useAuth();
    const isAdmin = user?.is_admin || user?.role === 'admin';


    const selectDashboardData = createSelector(
        (state) => state.Layout,
        (sidebarVisibilitytype) => sidebarVisibilitytype.sidebarVisibilitytype
      );
    // Inside your component
    const sidebarVisibilitytype = useSelector(selectDashboardData);

    // eBay Connection Status
    const [ebayConnected, setEbayConnected] = useState<boolean | null>(null);
    const [ebayTooltipOpen, setEbayTooltipOpen] = useState(false);
    const [ebayChecking, setEbayChecking] = useState(false);

    // Product Limits
    const [productLimits, setProductLimits] = useState<{
        current_products: number;  // managed products (counts toward limit)
        max_products: number;
        product_usage_percent: number;
        is_product_limit_reached: boolean;
        unmanaged_products: number;  // products over limit (not auto-updated)
        total_ebay_listings: number; // all eBay listings
        credits: number;
    } | null>(null);
    const [limitsTooltipOpen, setLimitsTooltipOpen] = useState(false);

    const checkEbayConnection = async () => {
        try {
            if (!token) {
                setEbayConnected(false);
                return;
            }
            setEbayChecking(true);
            const data = await ebayApi.getConnectionStatus();
            // API returns JSON directly
            if (data && typeof data.connected !== 'undefined') {
                setEbayConnected(data.connected === true && data.expired !== true);
            } else {
                setEbayConnected(false);
            }
        } catch (error) {
            console.error("eBay status check failed:", error);
            setEbayConnected(false);
        } finally {
            setEbayChecking(false);
        }
    };

    const fetchProductLimits = async () => {
        try {
            if (!token) return;
            const response = await productsApi.getLimits();
            if (response?.success && response?.data) {
                setProductLimits({
                    current_products: response.data.current_products || 0,
                    max_products: response.data.max_products || 100,
                    product_usage_percent: response.data.product_usage_percent || 0,
                    is_product_limit_reached: response.data.is_product_limit_reached || false,
                    unmanaged_products: response.data.unmanaged_products || 0,
                    total_ebay_listings: response.data.total_ebay_listings || 0,
                    credits: response.data.credits || 0
                });
            }
        } catch (error) {
            console.error("Failed to fetch product limits:", error);
        }
    };

    useEffect(() => {
        checkEbayConnection();
        fetchProductLimits();
        // Check every 60 seconds
        const cleanup = createSmartInterval(() => {
            checkEbayConnection();
            fetchProductLimits();
        }, POLLING_INTERVALS.EBAY_CONNECTION, { runImmediately: false, runOnVisible: true });

        // Listen for credit update events (instant refresh after purchase/consumption)
        const handleCreditsUpdate = () => fetchProductLimits();
        window.addEventListener('coderom-credits-updated', handleCreditsUpdate);
        // [ODEME-DONUS] odeme onaylaninca (usePaymentReturnPoll -> abonelikTazele) ust cubuk F5 beklemeden yeniden okunur
        const handleSubscriptionUpdate = () => {
            checkEbayConnection();
            fetchProductLimits();
        };
        window.addEventListener(ABONELIK_GUNCELLENDI_OLAYI, handleSubscriptionUpdate);

        return () => {
            cleanup();
            window.removeEventListener('coderom-credits-updated', handleCreditsUpdate);
            window.removeEventListener(ABONELIK_GUNCELLENDI_OLAYI, handleSubscriptionUpdate);
        };
    }, [token]);

    const [search, setSearch] = useState<boolean>(false);
    const toogleSearch = () => {
        setSearch(!search);
    };

    const toogleMenuBtn = () => {
        var windowSize = document.documentElement.clientWidth;
        const humberIcon = document.querySelector(".hamburger-icon") as HTMLElement;
        dispatch(changeSidebarVisibility("show"));

        if (windowSize > 767)
            humberIcon.classList.toggle('open');

        //For collapse horizontal menu
        if (document.documentElement.getAttribute('data-layout') === "horizontal") {
            document.body.classList.contains("menu") ? document.body.classList.remove("menu") : document.body.classList.add("menu");
        }

        //For collapse vertical and semibox menu
        if (sidebarVisibilitytype === "show" && (document.documentElement.getAttribute('data-layout') === "vertical" || document.documentElement.getAttribute('data-layout') === "semibox")) {
            if (windowSize < 1025 && windowSize > 767) {
                document.body.classList.remove('vertical-sidebar-enable');
                (document.documentElement.getAttribute('data-sidebar-size') === 'sm') ? document.documentElement.setAttribute('data-sidebar-size', '') : document.documentElement.setAttribute('data-sidebar-size', 'sm');
            } else if (windowSize > 1025) {
                document.body.classList.remove('vertical-sidebar-enable');
                (document.documentElement.getAttribute('data-sidebar-size') === 'lg') ? document.documentElement.setAttribute('data-sidebar-size', 'sm') : document.documentElement.setAttribute('data-sidebar-size', 'lg');
            } else if (windowSize <= 767) {
                document.body.classList.add('vertical-sidebar-enable');
                document.documentElement.setAttribute('data-sidebar-size', 'lg');
            }
        }


        //Two column menu
        if (document.documentElement.getAttribute('data-layout') === "twocolumn") {
            document.body.classList.contains('twocolumn-panel') ? document.body.classList.remove('twocolumn-panel') : document.body.classList.add('twocolumn-panel');
        }
    };

    return (
        <React.Fragment>
            {isImpersonating && (
                <div style={{
                    background: 'linear-gradient(90deg, #dc3545, #c82333)',
                    color: '#fff',
                    padding: '8px 16px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '12px',
                    fontSize: '13px',
                    fontWeight: 600,
                    zIndex: 1100,
                    position: 'relative',
                }}>
                    <i className="ri-spy-line" style={{ fontSize: '16px' }}></i>
                    <span>Viewing as: <strong>{user?.email}</strong></span>
                    <button
                        onClick={exitImpersonation}
                        style={{
                            background: 'rgba(255,255,255,0.2)',
                            border: '1px solid rgba(255,255,255,0.4)',
                            color: '#fff',
                            borderRadius: '4px',
                            padding: '2px 12px',
                            cursor: 'pointer',
                            fontSize: '12px',
                            fontWeight: 600,
                        }}
                    >
                        Exit Impersonation
                    </button>
                </div>
            )}
            <header id="page-topbar" className={headerClass}>
                <div className="layout-width">
                    <div className="navbar-header">
                        <div className="d-flex">

                            <div className="navbar-brand-box horizontal-logo">
                                <Link to="/" className="logo" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <span className="logo-sm">
                                        <img src="/icon.png" alt="CodeRom" style={{ height: '28px', width: 'auto' }} />
                                    </span>
                                    <span className="logo-lg">
                                        <img src="/logo-full.png" alt="CodeRom" style={{ height: '34px', width: 'auto' }} />
                                    </span>
                                </Link>
                            </div>

                            <button
                                onClick={toogleMenuBtn}
                                type="button"
                                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                                id="topnav-hamburger-icon">
                                <span className="hamburger-icon">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </span>
                            </button>


                            <SearchOption />
                        </div>

                        <div className="d-flex align-items-center">

                            <Dropdown isOpen={search} toggle={toogleSearch} className="d-md-none topbar-head-dropdown header-item">
                                <DropdownToggle type="button" tag="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle">
                                    <i className="bx bx-search fs-22"></i>
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
                                    <Form className="p-3">
                                        <div className="form-group m-0">
                                            <div className="input-group">
                                                <input type="text" className="form-control" placeholder="Search ..."
                                                    aria-label="Recipient's username" />
                                                <button className="btn btn-primary" type="submit"><i
                                                    className="mdi mdi-magnify"></i></button>
                                            </div>
                                        </div>
                                    </Form>
                                </DropdownMenu>
                            </Dropdown>

                            {/* eBay Connection Status - Hide for admin users */}
                            {!isAdmin && (
                                <div className="header-item d-none d-sm-flex" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <div
                                        id="ebay-status-badge"
                                        className="d-flex align-items-center"
                                        onClick={() => {
                                            // Only clickable when not connected
                                            // DE-05: burada marketplace secimi YOK; eskiden getAuthUrl("EBAY_GB")
                                            // literal argumaniyla cagriliyordu -> DE/FR/IT kullanicisi da GB baglaniyordu
                                            // (Lesson 108, 3 halkali sessiz zincir). Kullaniciyi marketplace dropdown'u
                                            // olan mevcut akisa yonlendir; OAuth'u orasi selectedMarketplace ile baslatir.
                                            if (ebayConnected === false) {
                                                window.location.href = "/ebay-connect";
                                            }
                                        }}
                                        style={{
                                            padding: '6px 12px',
                                            borderRadius: '20px',
                                            background: (ebayConnected === null || ebayChecking) ? '#f3f4f6' : ebayConnected ? 'linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)' : 'linear-gradient(135deg, #fef2f2 0%, #fecaca 100%)',
                                            border: (ebayConnected === null || ebayChecking) ? '1px solid #e5e7eb' : ebayConnected ? '1px solid #86efac' : '1px solid #fca5a5',
                                            marginRight: '4px',
                                            transition: 'all 0.2s ease',
                                            cursor: ebayConnected === false ? 'pointer' : 'default',
                                            opacity: ebayConnected === false ? 1 : 0.95
                                        }}
                                    >
                                        <img
                                            src="/images/logos/EBay_logo.svg.png"
                                            alt="eBay"
                                            style={{ height: '14px', marginRight: '6px' }}
                                        />
                                        {(ebayConnected === null || ebayChecking) ? (
                                            <span style={{ fontSize: '11px', color: '#6b7280', fontWeight: 500, display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                <i className="ri-loader-4-line" style={{ fontSize: '12px', animation: 'spin 1s linear infinite' }}></i>
                                                Checking...
                                            </span>
                                        ) : ebayConnected ? (
                                            <span style={{ fontSize: '11px', color: '#15803d', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                <i className="ri-checkbox-circle-fill" style={{ fontSize: '12px' }}></i>
                                                Connected
                                            </span>
                                        ) : (
                                            <span style={{ fontSize: '11px', color: '#dc2626', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                <i className="ri-error-warning-fill" style={{ fontSize: '12px' }}></i>
                                                Not Connected
                                            </span>
                                        )}
                                    </div>
                                    <Tooltip
                                        isOpen={ebayTooltipOpen}
                                        target="ebay-status-badge"
                                        toggle={() => setEbayTooltipOpen(!ebayTooltipOpen)}
                                        placement="bottom"
                                    >
                                        {ebayConnected ? 'eBay API connected and working.' : 'eBay account not connected. Click to reconnect.'}
                                    </Tooltip>
                                </div>
                            )}

                            {/* Product Limits Indicator */}
                            {productLimits && productLimits.max_products > 0 && (
                                <div className="header-item d-none d-sm-flex" style={{ display: 'flex', alignItems: 'center' }}>
                                    <Link
                                        to="/pricing"
                                        id="product-limits-badge"
                                        className="d-flex align-items-center text-decoration-none"
                                        style={{
                                            padding: '6px 12px',
                                            borderRadius: '20px',
                                            background: productLimits.is_product_limit_reached
                                                ? 'linear-gradient(135deg, #fef2f2 0%, #fecaca 100%)'
                                                : productLimits.product_usage_percent >= 80
                                                    ? 'linear-gradient(135deg, #fefce8 0%, #fef08a 100%)'
                                                    : 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
                                            border: productLimits.is_product_limit_reached
                                                ? '1px solid #fca5a5'
                                                : productLimits.product_usage_percent >= 80
                                                    ? '1px solid #fcd34d'
                                                    : '1px solid #7dd3fc',
                                            marginRight: '4px',
                                            transition: 'all 0.2s ease',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <i
                                            className={productLimits.is_product_limit_reached ? 'ri-error-warning-fill' : 'ri-stack-line'}
                                            style={{
                                                fontSize: '14px',
                                                marginRight: '6px',
                                                color: productLimits.is_product_limit_reached
                                                    ? '#dc2626'
                                                    : productLimits.product_usage_percent >= 80
                                                        ? '#d97706'
                                                        : '#0284c7'
                                            }}
                                        ></i>
                                        <span style={{
                                            fontSize: '11px',
                                            fontWeight: 600,
                                            color: productLimits.is_product_limit_reached
                                                ? '#dc2626'
                                                : productLimits.product_usage_percent >= 80
                                                    ? '#d97706'
                                                    : '#0284c7'
                                        }}>
                                            {productLimits.current_products}/{productLimits.max_products}
                                        </span>
                                    </Link>
                                    <Tooltip
                                        isOpen={limitsTooltipOpen}
                                        target="product-limits-badge"
                                        toggle={() => setLimitsTooltipOpen(!limitsTooltipOpen)}
                                        placement="bottom"
                                    >
                                        {productLimits.is_product_limit_reached
                                            ? `Limit reached! ${productLimits.unmanaged_products > 0 ? `${productLimits.unmanaged_products} products not auto-updated.` : ''} Click to upgrade.`
                                            : productLimits.product_usage_percent >= 80
                                                ? `${productLimits.product_usage_percent.toFixed(0)}% used. ${productLimits.unmanaged_products > 0 ? `${productLimits.unmanaged_products} unmanaged.` : ''}`
                                                : `${productLimits.current_products} managed products. ${productLimits.unmanaged_products > 0 ? `${productLimits.unmanaged_products} not auto-updated.` : ''}`}
                                    </Tooltip>
                                </div>
                            )}

                            {/* Credits Badge */}
                            {!isAdmin && productLimits && (
                                <div className="header-item d-none d-sm-flex" style={{ display: 'flex', alignItems: 'center' }}>
                                    <Link
                                        to="/subscription"
                                        id="credits-badge"
                                        className="d-flex align-items-center text-decoration-none"
                                        style={{
                                            padding: '6px 12px',
                                            borderRadius: '20px',
                                            background: productLimits.credits === 0
                                                ? 'linear-gradient(135deg, #fef2f2 0%, #fecaca 100%)'
                                                : productLimits.credits < 10
                                                    ? 'linear-gradient(135deg, #fefce8 0%, #fef08a 100%)'
                                                    : 'linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%)',
                                            border: productLimits.credits === 0
                                                ? '1px solid #fca5a5'
                                                : productLimits.credits < 10
                                                    ? '1px solid #fcd34d'
                                                    : '1px solid #c4b5fd',
                                            marginRight: '4px',
                                            transition: 'all 0.2s ease',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <i
                                            className="ri-copper-coin-line"
                                            style={{
                                                fontSize: '14px',
                                                marginRight: '6px',
                                                color: productLimits.credits === 0
                                                    ? '#dc2626'
                                                    : productLimits.credits < 10
                                                        ? '#d97706'
                                                        : '#7c3aed'
                                            }}
                                        ></i>
                                        <span style={{
                                            fontSize: '11px',
                                            fontWeight: 600,
                                            color: productLimits.credits === 0
                                                ? '#dc2626'
                                                : productLimits.credits < 10
                                                    ? '#d97706'
                                                    : '#7c3aed'
                                        }}>
                                            {productLimits.credits} credits
                                        </span>
                                    </Link>
                                </div>
                            )}

                            {/* LanguageDropdown */}
                            <LanguageDropdown />

                            {/* FullScreenDropdown */}
                            <FullScreenDropdown />

                            {/* Dark/Light Mode set */}
                            <LightDark
                                layoutMode={layoutModeType}
                                onChangeLayoutMode={onChangeLayoutMode}
                            />

                            {/* NotificationDropdown */}
                            <NotificationDropdown />

                            {/* ProfileDropdown */}
                            <ProfileDropdown />
                        </div>
                    </div>
                </div>
            </header>
        </React.Fragment>
    );
};

export default Header;